import FeatureOrUpgradeButton from 'garaje/components/feature-or-upgrade-button';

export default class FeatureOrHide extends FeatureOrUpgradeButton {}
